import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SmartWizLogo from "../../../../components/Logos/SmartWizLogo";
import { Loader } from "@mantine/core";
import { logout } from "../../../../utils/api";
import { disconnectNotificationSocket } from "@/utils/websocket/websocket";

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async (): Promise<void> => {
      disconnectNotificationSocket(); // Close WebSocket
      await logout();
    };
    performLogout();
  }, [navigate]);

  return (
    <div className="loader">
      <SmartWizLogo />
      <br />
      <Loader />
    </div>
  );
};

export default Logout;
